import { PayloadAction } from '@reduxjs/toolkit';
import { all, call, put, take, takeLeading } from 'typed-redux-saga';

import { createBroadcastAction } from '../../../call/features/broadcast/slice';
import { connectedToConferenceDoneAction } from '../../../call/features/conference/slice';
import { createCallSaga } from '../../../main/features/create-call/sagas/create-call';
import { startBroadcastFromFormAction, StartBroadcastFromFormActionInterface } from './slice';

/**
 *
 */
function* startBroadcastFromFormSaga({ payload }: PayloadAction<StartBroadcastFromFormActionInterface>) {
    yield* call(createCallSaga, {
        access_level: payload?.accessLevel,
    });
    yield* take(connectedToConferenceDoneAction.type);
    yield* put(createBroadcastAction({ ...payload }));
}

/**
 *
 */
export default function* rootCreateBroadcastSaga() {
    yield* all([takeLeading(startBroadcastFromFormAction.type, startBroadcastFromFormSaga)]);
}
